import React, { Suspense, useContext } from 'react'
import { useLocation, Switch, useRouteMatch, Route, useHistory } from 'react-router-dom'
import { Container } from '@material-ui/core'
import { ClaimSelectPolicy } from './ClaimSelectPolicy'
import { ClaimEnter } from './ClaimEnter'
import { lazyWithPreload } from '../../utilities/RLazyLoading'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import { isMobile } from 'react-device-detect'
import ClaimContext from '../../context/ClaimContext'
import { ClaimIncidentInfo } from './ClaimIncidentInfo'
import { ClaimHullInfo } from './ClaimHullInfo'
import { ClaimInfoFilesUploadStep } from './ClaimInfoFilesUploadStep'
import { ClaimFinish } from './ClaimFinish'
import { SkywatchClaimsProgressBar } from '../Core/SkywatchClaimsProgressBar'
import { LoginProtectedRoute } from '../Core/Routes/LoginProtectedRoute'
import { ClaimRouteGuard } from './ClaimRouteGuard'
import { ClaimNoticeInformation } from './ClaimNoticeInformation'
import { SessionService } from '../../services/SessionService'
import { BlueGrayBox } from '../Core/BlueGrayBox'
import { SessionContextStore } from '../../context/SessionContext'
import FlexView from 'react-flexview/lib'
const FlowLogin = lazyWithPreload(() => import("../Login/FlowLogin").then(module => ({ default: module.FlowLogin })))
const classNames = require('classnames')

export const ClaimRouter = () => {
    const location = useLocation()
    const history = useHistory()
    const sessionContext = useContext(SessionContextStore)
    const { path, url } = useRouteMatch();

    React.useEffect(() => {
        let id = EventEmitterService.subscribe(EventKey.FLOW_GO_BACK, () => {
            switch(location.pathname) {
                case url + '/process/claim':
                    history.replace(url + '/process/hull')
                    break
                case url + '/process/hull':
                    history.replace(url + '/process/info')
                    break
                case url + '/process/info':
                    history.replace(url + '/process/policy')
                    break
                case url + '/process/policy':
                    history.replace(url + '/process/notice')
                    break
                case url + '/process/notice':
                    history.replace(url)
                    break
                default: 
                    history.goBack()
                    break
            }
        })

        return function cleanup() {
            EventEmitterService.unsubscribe(EventKey.FLOW_GO_BACK, id)
        }

    }, [location])

    React.useEffect(() => {

        const handleClaimFlow = (eventKey) => {
            switch(eventKey) {
                case EventKey.CLAIM_NOTICE_INFO:
                    history.push(url + '/process/notice')
                    break
                case EventKey.CLAIM_SELECT_POLICY:
                    history.push(url + '/process/policy')
                    break
                case EventKey.CLAIM_POLICY_SELECTED:
                    history.push(url + '/process/info')
                    break
                case EventKey.CLAIM_INCIDENT_INFO_FINISHED:
                    history.push(url + '/process/hull')
                    break
                case EventKey.CLAIM_HULL_INFO_FINISHED:
                    history.push(url + '/process/claim')
                    break
                case EventKey.CLAIM_FILES_INFO_FINISHED:
                    history.push(url + '/process/finish')
                    break
            }
        }
        
        let id1 = EventEmitterService.subscribe(EventKey.CLAIM_SELECT_POLICY, () => {
            handleClaimFlow(EventKey.CLAIM_SELECT_POLICY)
        })

        let id2 = EventEmitterService.subscribe(EventKey.CLAIM_POLICY_SELECTED, () => {
            handleClaimFlow(EventKey.CLAIM_POLICY_SELECTED)
        })

        let id3 = EventEmitterService.subscribe(EventKey.CLAIM_INCIDENT_INFO_FINISHED, () => {
            handleClaimFlow(EventKey.CLAIM_INCIDENT_INFO_FINISHED)
        })

        let id4 = EventEmitterService.subscribe(EventKey.CLAIM_HULL_INFO_FINISHED, () => {
            handleClaimFlow(EventKey.CLAIM_HULL_INFO_FINISHED)
        })

        let id5 = EventEmitterService.subscribe(EventKey.CLAIM_FILES_INFO_FINISHED, () => {
            handleClaimFlow(EventKey.CLAIM_FILES_INFO_FINISHED)
        })

        let id6 = EventEmitterService.subscribe(EventKey.CLAIM_NOTICE_INFO, () => {
            handleClaimFlow(EventKey.CLAIM_NOTICE_INFO)
        })

        return function cleanup() {
            EventEmitterService.unsubscribe(EventKey.CLAIM_SELECT_POLICY, id1)
            EventEmitterService.unsubscribe(EventKey.CLAIM_POLICY_SELECTED, id2)
            EventEmitterService.unsubscribe(EventKey.CLAIM_INCIDENT_INFO_FINISHED, id3)
            EventEmitterService.unsubscribe(EventKey.CLAIM_HULL_INFO_FINISHED, id4)
            EventEmitterService.unsubscribe(EventKey.CLAIM_FILES_INFO_FINISHED, id5)
            EventEmitterService.unsubscribe(EventKey.CLAIM_NOTICE_INFO, id6)
        }
    }, [])


    return ( 
        <Switch>
            <Container className="margin-top-basic">
                {location.pathname != `${url}/process/finish` && <FlexView vAlignContent={'center'}>
                    <div className={classNames("text-promotion black bolder", {'textcenter': isMobile})}>SkyWatch.AI Claims Portal</div>
                    {SessionService.isBroker() && <div className='text-tiny margin-left-6'><BlueGrayBox>{sessionContext.user.email}</BlueGrayBox></div>}
                </FlexView>}
                
                {!(location.pathname == url || location.pathname == `${url}/process/finish` || location.pathname == `${url}/process/notice`) 
                    && <Suspense fallback={<div />}>
                    <SkywatchClaimsProgressBar />
                </Suspense>}

                <LoginProtectedRoute redirectTo={url} path={`${url}/process`}>
                    <ClaimContext>
                        <Route path={`${url}/process/notice`} component={ClaimNoticeInformation} />
                        <Route path={`${url}/process/policy`} component={ClaimSelectPolicy} />
                        <ClaimRouteGuard path={`${url}/process/info`}>
                            <ClaimIncidentInfo />
                        </ClaimRouteGuard>
                        <ClaimRouteGuard path={`${url}/process/hull`}>
                            <ClaimHullInfo />
                        </ClaimRouteGuard> 
                        <ClaimRouteGuard path={`${url}/process/claim`}>
                            <ClaimInfoFilesUploadStep />
                        </ClaimRouteGuard>
                        <Route path={`${url}/process/finish`} component={ClaimFinish} />
                    </ClaimContext>
                </LoginProtectedRoute>
                
            
                <Route path={url} exact component={ClaimEnter} />
            </Container>

        </Switch>
    )

}